import { api as pictionaryApi } from './auto-generated/pictionary'
import { api as eventApi } from './auto-generated/event'

pictionaryApi.enhanceEndpoints({
  endpoints: {
    pictionaryJoinGame: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        dispatch(
          eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
            draftEvent.event_type = 'PICTIONARY'
          }),
        )
        dispatch(
          eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
            draftEvent.event_type = 'PICTIONARY'
          }),
        )
        try {
          await queryFulfilled
        } catch {}
      },
    },
  },
})

export { pictionaryApi }
